import CoverPlansExplorer from "../../components/CoverPlansExplorer/CoverPlansExplorer";
import { explorePlansApi } from "../../services/explorePlansApi";

const CustomizeCoverView = () => {
  return <CoverPlansExplorer endpoint={explorePlansApi.baseEndpoint} />;
};

export default CustomizeCoverView;